export const DASHBOARD = '/';
export const TWEETS = '/tweets';
export const ABOUT = '/about';